module.exports = __webpack_public_path__ + "img/insurance-fund.b9b8b719.jpg";